import { connect } from 'react-redux';

import {
  createIframeEmbedContentItem
} from 'zoomforth_codesbane_editor/action_creators/content.js';

import {
  closeModal
} from 'zoomforth_codesbane_editor/action_creators/editor_modals.js';

import IframeEmbedCreator from './iframe_embed_creator.jsx';

const mapStateToProps = () => {
  return {};
};


const mapDispatchToProps = (dispatch, { section }) => (
  {
    onSave: (url)=> {
      dispatch(createIframeEmbedContentItem(section, url));
      dispatch(closeModal());
    },
    onCancel: ()=> {
      dispatch(closeModal());
    }
  }
);

const IframeEmbedSectionCreatorModal = connect(
  mapStateToProps,
  mapDispatchToProps
)(IframeEmbedCreator);

IframeEmbedSectionCreatorModal.editorModalName = 'IframeEmbedSectionCreatorModal';

export default IframeEmbedSectionCreatorModal;
